import { ADDONS_ENUM } from '@/components/shared/components/add-to-cart-button/add-to-cart-modal/type';

export const isAddonDisabled = (currentType, currentExcludes, addonsState, allAddonsList) => {
  if (currentType === ADDONS_ENUM.REPEAT_PURCHASE) {
    const hasOtherSelected = allAddonsList.some(
      (addon) =>
        addon.type !== ADDONS_ENUM.REPEAT_PURCHASE && addonsState[addon.type]?.selected,
    );

    if (hasOtherSelected) {
      return true;
    }
  } else {
    if (addonsState[ADDONS_ENUM.REPEAT_PURCHASE]?.selected) {
      return true;
    }

    if (Array.isArray(currentExcludes) && currentExcludes.length > 0) {
      const hasConflictFromCurrent = currentExcludes.some(
        (excludedType) => addonsState[excludedType]?.selected,
      );
      if (hasConflictFromCurrent) return true;
    }

    const hasConflictFromOthers = allAddonsList.some((otherAddon) => {
      if (!addonsState[otherAddon.type]?.selected) return false;
      if (Array.isArray(otherAddon.excludes) && otherAddon.excludes.includes(currentType)) {
        return true;
      }
      return false;
    });

    if (hasConflictFromOthers) return true;
  }

  return false;
};
